const InfoIcon = ({
  size = 14,
  color = "#99A1AF",
  strokeWidth = 1.1667,
  isActive = false,
  className = "",
}) => {
  const activeColor = isActive ? "#2563eb" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_info)">
        <path
          d="M7 12.8334C10.2217 12.8334 12.8333 10.2217 12.8333 7.00002C12.8333 3.77836 10.2217 1.16669 7 1.16669C3.77834 1.16669 1.16667 3.77836 1.16667 7.00002C1.16667 10.2217 3.77834 12.8334 7 12.8334Z"
          stroke={activeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 9.33333V7"
          stroke={activeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 4.66669H7.00583"
          stroke={activeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_info">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoIcon;
